import { NgModule, Injectable, ɵɵdefineInjectable, ɵɵinject, Component, ChangeDetectionStrategy, ViewContainerRef, Directive, ElementRef, ComponentFactoryResolver, Renderer2, Input, HostBinding, Pipe, Inject, LOCALE_ID, InjectionToken, NgZone, Injector, PLATFORM_ID } from '@angular/core';
import { from, BehaviorSubject, throwError, of, Observable } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { CommonModule as CommonModule$1, DatePipe, registerLocaleData, DecimalPipe, isPlatformBrowser } from '@angular/common';
import { __extends, __read, __values, __spread } from 'tslib';
import { TranslateService as TranslateService$1, TranslateModule } from '@ngx-translate/core';
import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';
import { Settings } from 'luxon';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en-US-POSIX';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { isEmpty as isEmpty$1 } from 'lodash-es';
import { Router, UrlSerializer } from '@angular/router';
import { AppInsightsService, ApplicationInsightsModule } from '@markpieszak/ng-application-insights';
import { AppInsightsService as AppInsightsService$1 } from '@markpieszak/ng-application-insights/dist/src/app-insight.service';
import { format } from 'date-fns';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} appLoadService
 * @return {?}
 */
function initAppConfiguration(appLoadService) {
    // https://github.com/ng-packagr/ng-packagr/issues/696
    // tslint:disable-next-line: prefer-immediate-return
    /** @type {?} */
    var fun = (/**
     * @return {?}
     */
    function () { return appLoadService.init(); });
    return fun;
}
var ConfigurationModule = /** @class */ (function () {
    function ConfigurationModule() {
    }
    ConfigurationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                },] }
    ];
    return ConfigurationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppConfigurationService = /** @class */ (function () {
    function AppConfigurationService() {
        this.configuration = {};
    }
    AppConfigurationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AppConfigurationService.ctorParameters = function () { return []; };
    /** @nocollapse */ AppConfigurationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AppConfigurationService_Factory() { return new AppConfigurationService(); }, token: AppConfigurationService, providedIn: "root" });
    return AppConfigurationService;
}());
if (false) {
    /** @type {?} */
    AppConfigurationService.prototype.configuration;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppInitService = /** @class */ (function () {
    function AppInitService(appConfigurationService) {
        this.appConfigurationService = appConfigurationService;
    }
    /**
     * @return {?}
     */
    AppInitService.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return from(fetch('assets/app-config.json').then((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            return response.json();
        }))).pipe(map((/**
         * @param {?} config
         * @return {?}
         */
        function (config) {
            _this.appConfigurationService.configuration = config;
            return;
        }))).toPromise();
    };
    AppInitService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AppInitService.ctorParameters = function () { return [
        { type: AppConfigurationService }
    ]; };
    /** @nocollapse */ AppInitService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AppInitService_Factory() { return new AppInitService(ɵɵinject(AppConfigurationService)); }, token: AppInitService, providedIn: "root" });
    return AppInitService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AppInitService.prototype.appConfigurationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CurrentUserModule = /** @class */ (function () {
    function CurrentUserModule() {
    }
    CurrentUserModule.decorators = [
        { type: NgModule, args: [{},] }
    ];
    return CurrentUserModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FcTokenService = /** @class */ (function () {
    function FcTokenService() {
        this.fcTokenSubject = new BehaviorSubject(null);
    }
    Object.defineProperty(FcTokenService.prototype, "currentFcToken", {
        get: /**
         * @return {?}
         */
        function () {
            return this.fcTokenSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FcTokenService.prototype.clean = /**
     * @return {?}
     */
    function () {
        this.fcTokenSubject.next(null);
    };
    /**
     * @param {?} fcToken
     * @return {?}
     */
    FcTokenService.prototype.setFcToken = /**
     * @param {?} fcToken
     * @return {?}
     */
    function (fcToken) {
        this.fcTokenSubject.next(fcToken);
    };
    Object.defineProperty(FcTokenService.prototype, "currentFcUser", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var token = this.currentFcToken;
            if (token == null) {
                return null;
            }
            /** @type {?} */
            var decodedToken = atob(token);
            if (token == null) {
                return null;
            }
            return JSON.parse(decodedToken);
        },
        enumerable: true,
        configurable: true
    });
    FcTokenService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ FcTokenService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FcTokenService_Factory() { return new FcTokenService(); }, token: FcTokenService, providedIn: "root" });
    return FcTokenService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FcTokenService.prototype.fcTokenSubject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FcTokenInterceptor = /** @class */ (function () {
    function FcTokenInterceptor(appConfigurationService, fcTokenService) {
        this.appConfigurationService = appConfigurationService;
        this.fcTokenService = fcTokenService;
        this.FC_TOKEN = 'fc-user';
        this.prefixUrl = this.appConfigurationService.configuration.api_url.toLowerCase();
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    FcTokenInterceptor.prototype.intercept = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        if (!this.appConfigurationService) {
            return next.handle(req);
        }
        if (!this.appConfigurationService.configuration) {
            return next.handle(req);
        }
        if (!this.appConfigurationService.configuration.api_url) {
            return next.handle(req);
        }
        if (!this.checkUrl(req.url)) {
            return next.handle(req);
        }
        /** @type {?} */
        var token = this.fcTokenService.currentFcToken;
        if (token == null) {
            return next.handle(req);
        }
        /** @type {?} */
        var headers = req.headers.set(this.FC_TOKEN, token);
        req = req.clone({ headers: headers });
        return next.handle(req);
    };
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    FcTokenInterceptor.prototype.checkUrl = /**
     * @private
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (url == null) {
            return false;
        }
        /** @type {?} */
        var requestUrl = url.toLowerCase();
        return requestUrl.startsWith(this.prefixUrl);
    };
    FcTokenInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FcTokenInterceptor.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: FcTokenService }
    ]; };
    return FcTokenInterceptor;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FcTokenInterceptor.prototype.prefixUrl;
    /**
     * @type {?}
     * @private
     */
    FcTokenInterceptor.prototype.FC_TOKEN;
    /**
     * @type {?}
     * @private
     */
    FcTokenInterceptor.prototype.appConfigurationService;
    /**
     * @type {?}
     * @private
     */
    FcTokenInterceptor.prototype.fcTokenService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FcTokenModule = /** @class */ (function () {
    function FcTokenModule() {
    }
    FcTokenModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: FcTokenInterceptor,
                            multi: true
                        }
                    ]
                },] }
    ];
    return FcTokenModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FcUser = /** @class */ (function () {
    function FcUser() {
    }
    return FcUser;
}());
if (false) {
    /** @type {?} */
    FcUser.prototype.id;
    /** @type {?} */
    FcUser.prototype.name;
    /** @type {?} */
    FcUser.prototype.surname;
    /** @type {?} */
    FcUser.prototype.displayName;
    /** @type {?} */
    FcUser.prototype.email;
    /** @type {?} */
    FcUser.prototype.tenantExtId;
    /** @type {?} */
    FcUser.prototype.targetOrganizationId;
    /** @type {?} */
    FcUser.prototype.homeOrganizationId;
    /** @type {?} */
    FcUser.prototype.homeOrganizationName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CurrentUserService = /** @class */ (function () {
    function CurrentUserService(fcService) {
        this.fcService = fcService;
    }
    /**
     * @return {?}
     */
    CurrentUserService.prototype.getCurrentUser = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var fcUser = this.fcService.currentFcUser;
        if (fcUser == null) {
            return null;
        }
        return {
            id: fcUser.id,
            firstName: fcUser.name || fcUser.displayName,
            lastName: fcUser.surname || fcUser.displayName,
            userName: fcUser.displayName
        };
    };
    CurrentUserService.decorators = [
        { type: Injectable, args: [{
                    providedIn: CurrentUserModule
                },] }
    ];
    /** @nocollapse */
    CurrentUserService.ctorParameters = function () { return [
        { type: FcTokenService }
    ]; };
    /** @nocollapse */ CurrentUserService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CurrentUserService_Factory() { return new CurrentUserService(ɵɵinject(FcTokenService)); }, token: CurrentUserService, providedIn: CurrentUserModule });
    return CurrentUserService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CurrentUserService.prototype.fcService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CurrentUser = /** @class */ (function () {
    function CurrentUser() {
    }
    return CurrentUser;
}());
if (false) {
    /** @type {?} */
    CurrentUser.prototype.id;
    /** @type {?} */
    CurrentUser.prototype.firstName;
    /** @type {?} */
    CurrentUser.prototype.lastName;
    /** @type {?} */
    CurrentUser.prototype.userName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var JsonStorageTranscoder = /** @class */ (function () {
    function JsonStorageTranscoder() {
    }
    /**
     * @template T
     * @param {?} value
     * @return {?}
     */
    JsonStorageTranscoder.encode = /**
     * @template T
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return JSON.stringify(value);
    };
    /**
     * @template T
     * @param {?} value
     * @return {?}
     */
    JsonStorageTranscoder.decode = /**
     * @template T
     * @param {?} value
     * @return {?}
     */
    function (value) {
        try {
            return JSON.parse(value);
        }
        catch (error) {
            return undefined;
        }
    };
    return JsonStorageTranscoder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.has = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.storage.getItem(key) !== null;
    };
    /**
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.remove = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.storage.removeItem(key);
    };
    /**
     * @return {?}
     */
    StorageService.prototype.clear = /**
     * @return {?}
     */
    function () {
        this.storage.clear();
    };
    /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    StorageService.prototype.getItem = /**
     * @template T
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var value = this.storage.getItem(key);
        return value != null ? JsonStorageTranscoder.decode(value) : undefined;
    };
    /**
     * @template T
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    StorageService.prototype.setItem = /**
     * @template T
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        /** @type {?} */
        var stringValue = JsonStorageTranscoder.encode(value);
        return this.storage.setItem(key, stringValue);
    };
    Object.defineProperty(StorageService.prototype, "storage", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return window.localStorage;
        },
        enumerable: true,
        configurable: true
    });
    StorageService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ StorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingSpinnerComponent = /** @class */ (function () {
    function LoadingSpinnerComponent(vcRef) {
        this.vcRef = vcRef;
    }
    LoadingSpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-loading-spinner',
                    template: "<div class=\"backdrop spinner-backdrop\"></div>\r\n<div class=\"wrapper\">\r\n    <div class=\"circle-spinner\"></div>\r\n</div>\r\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".backdrop{opacity:.5;position:absolute;top:0;left:0;right:0;bottom:0;z-index:2000}.wrapper{position:absolute;z-index:2001;top:50%;left:50%;transform:translate(-50%,-50%);max-height:2em}"]
                }] }
    ];
    /** @nocollapse */
    LoadingSpinnerComponent.ctorParameters = function () { return [
        { type: ViewContainerRef }
    ]; };
    return LoadingSpinnerComponent;
}());
if (false) {
    /** @type {?} */
    LoadingSpinnerComponent.prototype.vcRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerDirective = /** @class */ (function () {
    function SpinnerDirective(el, vcRef, cfResolver, renderer) {
        this.el = el;
        this.vcRef = vcRef;
        this.cfResolver = cfResolver;
        this.renderer = renderer;
        this.elementClass = true;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    SpinnerDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.show) {
            if (changes.show.currentValue) {
                this.createSpinner();
            }
            else {
                this.destroySpinner();
            }
        }
    };
    /**
     * @return {?}
     */
    SpinnerDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.destroySpinner();
    };
    /**
     * @private
     * @return {?}
     */
    SpinnerDirective.prototype.createSpinner = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var spinnerComponentFactory = this.cfResolver.resolveComponentFactory(LoadingSpinnerComponent);
        this.spinnerComponentRef = this.vcRef.createComponent(spinnerComponentFactory);
        this.renderer.appendChild(this.vcRef.element.nativeElement, this.spinnerComponentRef.injector.get(LoadingSpinnerComponent).vcRef.element.nativeElement);
    };
    /**
     * @private
     * @return {?}
     */
    SpinnerDirective.prototype.destroySpinner = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.spinnerComponentRef) {
            this.spinnerComponentRef.destroy();
        }
    };
    SpinnerDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[appSpinner]',
                },] }
    ];
    /** @nocollapse */
    SpinnerDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ViewContainerRef },
        { type: ComponentFactoryResolver },
        { type: Renderer2 }
    ]; };
    SpinnerDirective.propDecorators = {
        show: [{ type: Input, args: ['appSpinner',] }],
        elementClass: [{ type: HostBinding, args: ['class.position-relative',] }]
    };
    return SpinnerDirective;
}());
if (false) {
    /** @type {?} */
    SpinnerDirective.prototype.show;
    /** @type {?} */
    SpinnerDirective.prototype.elementClass;
    /**
     * @type {?}
     * @private
     */
    SpinnerDirective.prototype.spinnerComponentRef;
    /**
     * @type {?}
     * @private
     */
    SpinnerDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    SpinnerDirective.prototype.vcRef;
    /**
     * @type {?}
     * @private
     */
    SpinnerDirective.prototype.cfResolver;
    /**
     * @type {?}
     * @private
     */
    SpinnerDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        this.statusChange = new BehaviorSubject(false);
        this.status$ = this.statusChange.asObservable();
    }
    Object.defineProperty(SpinnerService.prototype, "display$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.status$;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SpinnerService.prototype.display = /**
     * @return {?}
     */
    function () {
        this.statusChange.next(true);
    };
    /**
     * @return {?}
     */
    SpinnerService.prototype.hide = /**
     * @return {?}
     */
    function () {
        this.statusChange.next(false);
    };
    SpinnerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SpinnerService.ctorParameters = function () { return []; };
    /** @nocollapse */ SpinnerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
    return SpinnerService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SpinnerService.prototype.statusChange;
    /**
     * @type {?}
     * @private
     */
    SpinnerService.prototype.status$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerModule = /** @class */ (function () {
    function SpinnerModule() {
    }
    SpinnerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LoadingSpinnerComponent, SpinnerDirective],
                    imports: [CommonModule$1],
                    entryComponents: [LoadingSpinnerComponent],
                    exports: [SpinnerDirective]
                },] }
    ];
    return SpinnerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// TODO: Should be moved to a separate module
var EnumTranslateKeyPipe = /** @class */ (function () {
    function EnumTranslateKeyPipe() {
    }
    /**
     * @param {?} value
     * @param {?} prefix
     * @return {?}
     */
    EnumTranslateKeyPipe.prototype.transform = /**
     * @param {?} value
     * @param {?} prefix
     * @return {?}
     */
    function (value, prefix) {
        if (value) {
            return prefix + "." + (value.charAt(0).toLocaleLowerCase() + value.slice(1));
        }
        return '';
    };
    EnumTranslateKeyPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'enumTranslateKey'
                },] }
    ];
    return EnumTranslateKeyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// // based on https://github.com/angular/angular/issues/15039#issuecomment-496133812
var I18nDatePipe = /** @class */ (function (_super) {
    __extends(I18nDatePipe, _super);
    function I18nDatePipe(locale, translate) {
        var _this = _super.call(this, locale) || this;
        _this.previousParams = [];
        _this.changeSubs = translate.onLangChange.subscribe((/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            // tslint:disable-next-line: no-any
            ((/** @type {?} */ (_this))).locale = $event.lang;
            _this.cache = null;
        }));
        return _this;
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} format
     * @param {?=} timezone
     * @param {?=} locale
     * @return {?}
     */
    I18nDatePipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} format
     * @param {?=} timezone
     * @param {?=} locale
     * @return {?}
     */
    function (value, format, timezone, locale) {
        /** @type {?} */
        var currentParams = [value, format, timezone, locale];
        if (!this.cache || !isEmpty(difference(this.previousParams, currentParams))) {
            this.previousParams = currentParams;
            this.cache = _super.prototype.transform.call(this, value, format, timezone, locale);
        }
        return this.cache;
    };
    /**
     * @return {?}
     */
    I18nDatePipe.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.changeSubs.unsubscribe();
    };
    I18nDatePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'i18nDate',
                    pure: false
                },] }
    ];
    /** @nocollapse */
    I18nDatePipe.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
        { type: TranslateService$1 }
    ]; };
    return I18nDatePipe;
}(DatePipe));
if (false) {
    /**
     * @type {?}
     * @private
     */
    I18nDatePipe.prototype.changeSubs;
    /**
     * @type {?}
     * @private
     */
    I18nDatePipe.prototype.cache;
    /**
     * @type {?}
     * @private
     */
    I18nDatePipe.prototype.previousParams;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DictionaryTranslateKeyPipe = /** @class */ (function () {
    function DictionaryTranslateKeyPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DictionaryTranslateKeyPipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value) {
            return "APPLICATION.DICTIONARIES." + value;
        }
        return '';
    };
    DictionaryTranslateKeyPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'dictionaryTranslateKey'
                },] }
    ];
    return DictionaryTranslateKeyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line: use-primitive-type
var  
// tslint:disable-next-line: use-primitive-type
DynamicLocaleId = /** @class */ (function (_super) {
    __extends(DynamicLocaleId, _super);
    function DynamicLocaleId(service) {
        var _this = _super.call(this) || this;
        _this.service = service;
        return _this;
    }
    /**
     * @return {?}
     */
    DynamicLocaleId.prototype.toString = /**
     * @return {?}
     */
    function () {
        return this.service.currentLang;
    };
    return DynamicLocaleId;
}(String));
if (false) {
    /**
     * @type {?}
     * @protected
     */
    DynamicLocaleId.prototype.service;
}
/** @type {?} */
var LocaleProvider = {
    provide: LOCALE_ID,
    useClass: DynamicLocaleId,
    deps: [TranslateService$1]
};
var TranslationModule = /** @class */ (function () {
    function TranslationModule() {
    }
    TranslationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        EnumTranslateKeyPipe,
                        DictionaryTranslateKeyPipe,
                        I18nDatePipe
                    ],
                    imports: [
                        CommonModule$1
                    ],
                    exports: [
                        TranslateModule,
                        EnumTranslateKeyPipe,
                        DictionaryTranslateKeyPipe,
                        I18nDatePipe
                    ],
                    providers: [
                        LocaleProvider
                    ]
                },] }
    ];
    return TranslationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var SupportedLanguages = {
    PL: 'pl',
    EN: 'en',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function TranslateModuleOptions() { }
if (false) {
    /** @type {?} */
    TranslateModuleOptions.prototype.defaultLanguage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var KEY_LANG = 'lang';
// NOTE: This value has to be exported otherwise the AoT compiler won't see it.
/** @type {?} */
var TRANSLATE_MODULE_OPTIONS_CONFIG = new InjectionToken('Translate Module Optionsx');
var TranslateService = /** @class */ (function () {
    function TranslateService(translateModuleOptions, translateService, storageService) {
        this.translateModuleOptions = translateModuleOptions;
        this.translateService = translateService;
        this.storageService = storageService;
        this.isInitialized = false;
    }
    /**
     * @param {?} lang
     * @return {?}
     */
    TranslateService.prototype.setLanguage = /**
     * @param {?} lang
     * @return {?}
     */
    function (lang) {
        this.initializeLuxon(lang);
        this.translateService.use(lang);
        this.storageService.setItem(KEY_LANG, lang);
    };
    /**
     * @return {?}
     */
    TranslateService.prototype.getLanguage = /**
     * @return {?}
     */
    function () {
        return this.storageService.getItem(KEY_LANG) || this.translateModuleOptions.defaultLanguage;
    };
    /**
     * @return {?}
     */
    TranslateService.prototype.supportedLanguages = /**
     * @return {?}
     */
    function () {
        return Object.entries(SupportedLanguages).map((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return value;
        }));
    };
    /**
     * @return {?}
     */
    TranslateService.prototype.initialize = /**
     * @return {?}
     */
    function () {
        if (!this.isInitialized) {
            /** @type {?} */
            var language = this.getLanguage();
            this.translateService.addLangs(Object.keys(SupportedLanguages));
            this.translateService.setDefaultLang(language);
            this.translateService.use(language);
            this.initializeLuxon(language);
            this.registerLocale();
            this.isInitialized = true;
        }
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    TranslateService.prototype.translate = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    function (key, interpolateParams) {
        return this.translateService.instant(key, interpolateParams);
    };
    /**
     * @private
     * @return {?}
     */
    TranslateService.prototype.registerLocale = /**
     * @private
     * @return {?}
     */
    function () {
        registerLocaleData(localePl, SupportedLanguages.PL);
        registerLocaleData(localeEn, SupportedLanguages.EN);
    };
    /**
     * @private
     * @param {?} lang
     * @return {?}
     */
    TranslateService.prototype.initializeLuxon = /**
     * @private
     * @param {?} lang
     * @return {?}
     */
    function (lang) {
        Settings.defaultLocale = lang;
    };
    TranslateService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TranslateService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [TRANSLATE_MODULE_OPTIONS_CONFIG,] }] },
        { type: TranslateService$1 },
        { type: StorageService }
    ]; };
    /** @nocollapse */ TranslateService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TranslateService_Factory() { return new TranslateService(ɵɵinject(TRANSLATE_MODULE_OPTIONS_CONFIG), ɵɵinject(TranslateService$1), ɵɵinject(StorageService)); }, token: TranslateService, providedIn: "root" });
    return TranslateService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TranslateService.prototype.isInitialized;
    /**
     * @type {?}
     * @private
     */
    TranslateService.prototype.translateModuleOptions;
    /**
     * @type {?}
     * @private
     */
    TranslateService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    TranslateService.prototype.storageService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationModule = /** @class */ (function () {
    function NotificationModule() {
    }
    NotificationModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule$1,
                        ToastrModule.forRoot()
                    ],
                    exports: [
                        ToastrModule
                    ]
                },] }
    ];
    return NotificationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ErrorMessageService = /** @class */ (function () {
    function ErrorMessageService(translateService) {
        this.translateService = translateService;
    }
    /**
     * @param {?} error
     * @param {?=} defaultMessage
     * @return {?}
     */
    ErrorMessageService.prototype.getTranslatedErrorMessage = /**
     * @param {?} error
     * @param {?=} defaultMessage
     * @return {?}
     */
    function (error, defaultMessage) {
        /** @type {?} */
        var errorMessage = defaultMessage || 'APPLICATION.ERRORS.unhandled';
        if (error instanceof HttpErrorResponse) {
            // No Internet connection
            if (!navigator.onLine) {
                return this.translateService.translate('APPLICATION.ERRORS.noConnection');
            }
            else if (this.isClientError(error) && error.error && error.error.code) {
                defaultMessage = defaultMessage || error.error.message || errorMessage;
                return this.getDefaultTranslation("API.ERRORS." + error.error.code, defaultMessage);
            }
        }
        return this.translateService.translate(errorMessage);
    };
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    ErrorMessageService.prototype.isClientError = /**
     * @private
     * @param {?} error
     * @return {?}
     */
    function (error) {
        // tslint:disable-next-line: no-magic-numbers
        return error != null && error.status >= 400 && error.status < 500;
    };
    /**
     * @private
     * @param {?} messageTranslationKey
     * @param {?} defaultKey
     * @return {?}
     */
    ErrorMessageService.prototype.getDefaultTranslation = /**
     * @private
     * @param {?} messageTranslationKey
     * @param {?} defaultKey
     * @return {?}
     */
    function (messageTranslationKey, defaultKey) {
        // https://github.com/ngx-translate/core/issues/1128
        // https://github.com/ngx-translate/core/issues/1128
        /** @type {?} */
        var translatedMessage = this.translateService.translate(messageTranslationKey);
        if (defaultKey != null && translatedMessage === messageTranslationKey) {
            // Translation for a specific key does not exist
            return this.translateService.translate(defaultKey);
        }
        return translatedMessage;
    };
    ErrorMessageService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ErrorMessageService.ctorParameters = function () { return [
        { type: TranslateService }
    ]; };
    /** @nocollapse */ ErrorMessageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErrorMessageService_Factory() { return new ErrorMessageService(ɵɵinject(TranslateService)); }, token: ErrorMessageService, providedIn: "root" });
    return ErrorMessageService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ErrorMessageService.prototype.translateService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationService = /** @class */ (function () {
    function NotificationService(toastr, translateService, errorMessageService) {
        this.toastr = toastr;
        this.translateService = translateService;
        this.errorMessageService = errorMessageService;
    }
    /**
     * @param {?} error
     * @param {?=} defaultMessage
     * @return {?}
     */
    NotificationService.prototype.error = /**
     * @param {?} error
     * @param {?=} defaultMessage
     * @return {?}
     */
    function (error, defaultMessage) {
        /** @type {?} */
        var errorMessage = this.errorMessageService.getTranslatedErrorMessage(error, defaultMessage);
        this.toastr.error(errorMessage);
    };
    /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    NotificationService.prototype.success = /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    function (messageTranslationKey) {
        this.toastr.success(this.translateService.translate(messageTranslationKey));
    };
    /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    NotificationService.prototype.info = /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    function (messageTranslationKey) {
        this.toastr.info(this.translateService.translate(messageTranslationKey));
    };
    /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    NotificationService.prototype.warning = /**
     * @param {?} messageTranslationKey
     * @return {?}
     */
    function (messageTranslationKey) {
        this.toastr.warning(this.translateService.translate(messageTranslationKey));
    };
    NotificationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    NotificationService.ctorParameters = function () { return [
        { type: ToastrService },
        { type: TranslateService },
        { type: ErrorMessageService }
    ]; };
    /** @nocollapse */ NotificationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(ɵɵinject(ToastrService), ɵɵinject(TranslateService), ɵɵinject(ErrorMessageService)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.toastr;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.errorMessageService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AirHumidityPipe = /** @class */ (function (_super) {
    __extends(AirHumidityPipe, _super);
    function AirHumidityPipe(locale) {
        return _super.call(this, locale) || this;
    }
    /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    AirHumidityPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    function (value, locale) {
        if (value == null) {
            return '-';
        }
        return _super.prototype.transform.call(this, value, '1.2-2', locale) + ' %';
    };
    AirHumidityPipe.decorators = [
        { type: Pipe, args: [{ name: 'airHumidity' },] }
    ];
    /** @nocollapse */
    AirHumidityPipe.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
    ]; };
    return AirHumidityPipe;
}(DecimalPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AirPressurePipe = /** @class */ (function (_super) {
    __extends(AirPressurePipe, _super);
    function AirPressurePipe(locale) {
        return _super.call(this, locale) || this;
    }
    /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    AirPressurePipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    function (value, locale) {
        if (value == null) {
            return '-';
        }
        return _super.prototype.transform.call(this, value / AirPressurePipe.hPa, '1.2-2', locale) + ' hPa';
    };
    AirPressurePipe.hPa = 100.0;
    AirPressurePipe.decorators = [
        { type: Pipe, args: [{ name: 'airPressure' },] }
    ];
    /** @nocollapse */
    AirPressurePipe.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
    ]; };
    return AirPressurePipe;
}(DecimalPipe));
if (false) {
    /**
     * @type {?}
     * @private
     */
    AirPressurePipe.hPa;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DefaultPipe = /** @class */ (function () {
    function DefaultPipe() {
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} defaultValue
     * @return {?}
     */
    DefaultPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} defaultValue
     * @return {?}
     */
    function (value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = '-'; }
        return isEmpty$1(value) ? defaultValue : value;
    };
    DefaultPipe.decorators = [
        { type: Pipe, args: [{ name: 'default' },] }
    ];
    return DefaultPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FarmPortalWeatherStationsReplaceLinkPipe = /** @class */ (function () {
    function FarmPortalWeatherStationsReplaceLinkPipe(router, serializer) {
        this.router = router;
        this.serializer = serializer;
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    FarmPortalWeatherStationsReplaceLinkPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        /** @type {?} */
        var regex = /\[link:farmportal:weather-detail:(.*):'(.*)'\]/g;
        if (regex.test(value)) {
            /** @type {?} */
            var url = this.prepareWeatherDetailUrlPrefix();
            return value.replace(/\[link:farmportal:weather-detail:(.*):'(.*)'\]/g, "<a href=\"" + url + "/$1\">$2</a>");
        }
        return value;
    };
    /**
     * @private
     * @return {?}
     */
    FarmPortalWeatherStationsReplaceLinkPipe.prototype.prepareWeatherDetailUrlPrefix = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var tree = this.router.createUrlTree(['weatherstations']);
        return this.serializer.serialize(tree);
    };
    FarmPortalWeatherStationsReplaceLinkPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'farmPortalWeatherStationsReplaceLink'
                },] }
    ];
    /** @nocollapse */
    FarmPortalWeatherStationsReplaceLinkPipe.ctorParameters = function () { return [
        { type: Router },
        { type: UrlSerializer }
    ]; };
    return FarmPortalWeatherStationsReplaceLinkPipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FarmPortalWeatherStationsReplaceLinkPipe.prototype.router;
    /**
     * @type {?}
     * @private
     */
    FarmPortalWeatherStationsReplaceLinkPipe.prototype.serializer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HtmlTextShortPipe = /** @class */ (function () {
    function HtmlTextShortPipe() {
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?} maxLenght
     * @return {?}
     */
    HtmlTextShortPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?} maxLenght
     * @return {?}
     */
    function (value, maxLenght) {
        if (value && value.length > 0) {
            /** @type {?} */
            var textParsed = value.replace(/<[^>]+>/g, ' ');
            if (textParsed.length < maxLenght) {
                return textParsed;
            }
            /** @type {?} */
            var textLimitedToMaxLength = textParsed.substring(0, maxLenght);
            return textLimitedToMaxLength + "...";
        }
        return '';
    };
    HtmlTextShortPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'htmlTextShort'
                },] }
    ];
    /** @nocollapse */
    HtmlTextShortPipe.ctorParameters = function () { return []; };
    return HtmlTextShortPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HumidityPipe = /** @class */ (function (_super) {
    __extends(HumidityPipe, _super);
    function HumidityPipe(locale) {
        return _super.call(this, locale) || this;
    }
    /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    HumidityPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    function (value, locale) {
        if (value == null) {
            return '-';
        }
        return _super.prototype.transform.call(this, value, '1.2-2', locale) + ' Cb';
    };
    HumidityPipe.decorators = [
        { type: Pipe, args: [{ name: 'humidity' },] }
    ];
    /** @nocollapse */
    HumidityPipe.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
    ]; };
    return HumidityPipe;
}(DecimalPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var EmployeeTaskType = {
    CropVerification: 'CropVerification',
    FarmVerification: 'FarmVerification',
    InterventionVisitVetting: 'InterventionVisitVetting',
    InterventionVisitOther: 'InterventionVisitOther',
    ProductCatalogAudit: 'ProductCatalogAudit',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
EnumItemGroup = /** @class */ (function () {
    function EnumItemGroup(value, group) {
        this.value = value;
        this.group = group;
    }
    return EnumItemGroup;
}());
if (false) {
    /** @type {?} */
    EnumItemGroup.prototype.value;
    /** @type {?} */
    EnumItemGroup.prototype.group;
}
/**
 * @return {?}
 */
function initEmployeeTaskTypeItemsGroup() {
    return [
        new EnumItemGroup(EmployeeTaskType.CropVerification, 'Verification'),
        new EnumItemGroup(EmployeeTaskType.FarmVerification, 'Verification'),
        new EnumItemGroup(EmployeeTaskType.InterventionVisitVetting, 'InterventionVisit'),
        new EnumItemGroup(EmployeeTaskType.InterventionVisitOther, 'InterventionVisit'),
        new EnumItemGroup(EmployeeTaskType.ProductCatalogAudit, 'ProductCatalogAudit')
    ];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var AgronomicCategory = {
    VeryLight: 'VeryLight',
    Light: 'Light',
    Average: 'Average',
    Heavy: 'Heavy',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var AlarmLocation = {
    EVERYWHERE: 'EVERYWHERE',
    GROUNDS: 'GROUNDS',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var AlarmThresholdProperty = {
    SPEED: 'SPEED',
    RPM: 'RPM',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ApplicationType = {
    CrmPortal: 'CrmPortal',
    FarmPortal: 'FarmPortal',
    SupplierPortal: 'SupplierPortal',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CertificateType = {
    ISO: 'ISO',
    FSSC: 'FSSC',
    IFSFOOD: 'IFSFOOD',
    QAFP: 'QAFP',
    QMP: 'QMP',
    PQS: 'PQS',
    ICB: 'ICB',
    PTIR: 'PTIR',
    VCERT: 'VCERT',
    IP: 'IP',
    GLOBALGAP: 'GLOBALGAP',
    BRC: 'BRC',
    EKO: 'EKO',
    GRASP: 'GRASP',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ComplexOfAgriculturalSuitability = {
    VeryGoodWheat: 'VeryGoodWheat',
    GoodWheat: 'GoodWheat',
    FaultyWheat: 'FaultyWheat',
    VeryGoodRye: 'VeryGoodRye',
    GoodRye: 'GoodRye',
    WeakRye: 'WeakRye',
    VeryWeakRye: 'VeryWeakRye',
    StrongGrainFodder: 'StrongGrainFodder',
    WeakGrainFodder: 'WeakGrainFodder',
    MountainWheat: 'MountainWheat',
    MountainGrain: 'MountainGrain',
    MountainOatPotato: 'MountainOatPotato',
    MountainOatFodder: 'MountainOatFodder',
    SoilUsedForGrasslands: 'SoilUsedForGrasslands',
    VeryGood: 'VeryGood',
    Good: 'Good',
    Average: 'Average',
    Weak: 'Weak',
    VeryWeak: 'VeryWeak',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ContractAgreementType = {
    TradeAgreement: 'TradeAgreement',
    ContractingAgreement: 'ContractingAgreement',
    ProductionAgreement: 'ProductionAgreement',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ContractStatusType = {
    Sended: 'Sended',
    Signed: 'Signed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ContractedProductUnit = {
    Kilogram: 'Kilogram',
    Piece: 'Piece',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Country = {
    Belarus: 'Belarus',
    Czechia: 'Czechia',
    Germany: 'Germany',
    Slovakia: 'Slovakia',
    Spain: 'Spain',
    Ukraine: 'Ukraine',
    Poland: 'Poland',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CultivationPotatoPurposeType = {
    ToEat: 'ToEat',
    ForChips: 'ForChips',
    ForFries: 'ForFries',
    ForStarch: 'ForStarch',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CultivationProtectionType = {
    OnGround: 'OnGround',
    UnderProtection: 'UnderProtection',
    PartlyUnderProtection: 'PartlyUnderProtection',
    Greenhouse: 'Greenhouse',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CultivationSubtype = {
    Agroforestry: 'Agroforestry',
    Mixed: 'Mixed',
    Traditional: 'Traditional',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CultivationType = {
    Conventional: 'Conventional',
    Ecological: 'Ecological',
    Agroecological: 'Agroecological',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CustomMapType = {
    Yield: 'Yield',
    CropHumidity: 'CropHumidity',
    MachineFill: 'MachineFill',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditConsumptionType = {
    A: 'A',
    B: 'B',
    C: 'C',
    AB: 'AB',
    AC: 'AC',
    BC: 'BC',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditDisease = {
    NotFound: 'NotFound',
    Found: 'Found',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditFleshColor = {
    White: 'White',
    WhiteWithGreyTint: 'WhiteWithGreyTint',
    Purple: 'Purple',
    Creamy: 'Creamy',
    LightYellow: 'LightYellow',
    Yellow: 'Yellow',
    DarkYellow: 'DarkYellow',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditQualitativeAssessment = {
    Normal: 'Normal',
    Damages: 'Damages',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditSkinColor = {
    White: 'White',
    Yellow: 'Yellow',
    Purple: 'Purple',
    Red: 'Red',
    Pink: 'Pink',
    UnevenlyColored: 'UnevenlyColored',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryAuditTuberShape = {
    Round: 'Round',
    Oval: 'Oval',
    Elongated: 'Elongated',
    RoundOval: 'RoundOval',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeliveryRatingCategoryType = {
    A: 'A',
    B: 'B',
    CS: 'CS',
    D: 'D',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DeviceType = {
    WeatherStation: 'WeatherStation',
    MoistureSensor: 'MoistureSensor',
    StorageMainSensor: 'StorageMainSensor',
    StoragePrismSensor: 'StoragePrismSensor',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DocumentEnumType = {
    Ground: 'Ground',
    FieldCard: 'Fieldcard',
    Document: 'Document',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var EmployeePosition = {
    Manager: 'Manager',
    Accountant: 'Accountant',
    Employee: 'Employee',
    Agronomist: 'Agronomist',
    ChairmanOfTheBoard: 'ChairmanOfTheBoard',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var EmploymentSalaryType = {
    PerHour: 'PerHour',
    PerHectare: 'PerHectare',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var EmploymentType = {
    Other: 'Other',
    EmploymentContract: 'EmploymentContract',
    MandateContract: 'MandateContract',
    Contract: 'Contract',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var FarmAuditStatus = {
    Failed: 'Failed',
    ToImprove: 'ToImprove',
    Passed: 'Passed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var FertilizerType = {
    Calcium: 'Calcium',
    Foliar: 'Foliar',
    GrowStimulator: 'GrowStimulator',
    Magnesium: 'Magnesium',
    Mineral: 'Mineral',
    MultiComponents: 'MultiComponents',
    Natural: 'Natural',
    Nitrogen: 'Nitrogen',
    NitrogenWithSulfur: 'NitrogenWithSulfur',
    Organic: 'Organic',
    OrganicMineral: 'OrganicMineral',
    Phosphorus: 'Phosphorus',
    Potassium: 'Potassium',
    Sulfur: 'Sulfur',
    TwoComponents: 'TwoComponents',
    Universal: 'Universal',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var FieldAuditAreaType = {
    ProductEthephon: 'ProductEthephon',
    ProductHeavyMetals: 'ProductHeavyMetals',
    ProductNitrates: 'ProductNitrates',
    ProductMicrobiology: 'ProductMicrobiology',
    ProductPesticides: 'ProductPesticides',
    ProductPesticidesExtended: 'ProductPesticidesExtended',
    SoilHeavyMetals: 'SoilHeavyMetals',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var FieldAuditType = {
    InterventionVisit: 'InterventionVisit',
    CropVerification: 'CropVerification',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var GeometryType = {
    Point: 0,
    MultiPoint: 1,
    LineString: 2,
    MultiLineString: 3,
    Polygon: 4,
    MultiPolygon: 5,
    GeometryCollection: 6,
};
GeometryType[GeometryType.Point] = 'Point';
GeometryType[GeometryType.MultiPoint] = 'MultiPoint';
GeometryType[GeometryType.LineString] = 'LineString';
GeometryType[GeometryType.MultiLineString] = 'MultiLineString';
GeometryType[GeometryType.Polygon] = 'Polygon';
GeometryType[GeometryType.MultiPolygon] = 'MultiPolygon';
GeometryType[GeometryType.GeometryCollection] = 'GeometryCollection';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var GroundCategory = {
    I: 'I',
    II: 'II',
    IIIa: 'IIIa',
    IIIb: 'IIIb',
    IVa: 'IVa',
    IVb: 'IVb',
    V: 'V',
    VI: 'VI',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var LimingType = {
    Redundant: 'Redundant',
    Moderated: 'Moderated',
    Advisable: 'Advisable',
    Needed: 'Needed',
    Necessary: 'Necessary',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MachineServiceCardType = {
    SERVICE: 'service',
    PART: 'part',
    LIQUID: 'liquid',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MachineServiceCardUnit = {
    UNIT: 'unit',
    LITER: 'liter',
    KG: 'kg',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MachineServiceType = {
    OWN: 'own',
    EXTERNAL: 'external',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ManureType = {
    None: 'None',
    Manure: 'Manure',
    BirdDroppings: 'BirdDroppings',
    Slurry: 'Slurry',
    LiquidManureCattle: 'LiquidManureCattle',
    LiquidManurePig: 'LiquidManurePig',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MapCultivationAreaModeEnum = {
    DRAWING_MODE: 'DrawingMode',
    SELECT_GROUNDS_MODE: 'SelectGroundsMode',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var MessageType = {
    Advertisement: 'Advertisement',
    Alert: 'Alert',
    Information: 'Information',
    Reminder: 'Reminder',
    Standard: 'Standard',
    Warning: 'Warning',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Month = {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditLaboratory = {
    Polcargo: 'Polcargo',
    Agrolab: 'Agrolab',
    Hamilton: 'Hamilton',
    Eurofis: 'Eurofis',
    Fertico: 'Fertico',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditPlace = {
    CentralStorage: 'CentralStorage',
    SupplierStorage: 'SupplierStorage',
    SupplierPlantation: 'SupplierPlantation',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditRecipient = {
    Company: 'Company',
    Client: 'Client',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditResult = {
    Compatible: 'Compatible',
    Incompatible: 'Incompatible',
    Acceptable: 'Acceptable',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditStatus = {
    SampleNotTaken: 'SampleNotTaken',
    SampleTaken: 'SampleTaken',
    NotSentToLaboratory: 'NotSentToLaboratory',
    SentToLaboratory: 'SentToLaboratory',
    AwaitingResultComment: 'AwaitingResultComment',
    AwaitingDirectorComment: 'AwaitingDirectorComment',
    AwaitingSupplierComment: 'AwaitingSupplierComment',
    ResultReceived: 'ResultReceived',
    Completed: 'Completed',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditType = {
    Primary: 'Primary',
    PrimarySupplierQualification: 'PrimarySupplierQualification',
    Unblocking: 'Unblocking',
    Verification: 'Verification',
    VerificationFromRamp: 'VerificationFromRamp',
    Commercial: 'Commercial',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogAuditViewType = {
    Technologist: 'Technologist',
    SecurityOffice: 'SecurityOffice',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ProductCatalogInfoStatus = {
    Blocked: 'Blocked',
    ConditionallyApproved: 'ConditionallyApproved',
    Approved: 'Approved',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var QualityAssessmentType = {
    Incorrect: 'Incorrect',
    Correct: 'Correct',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var RainfallYearType = {
    VeryDry: 'VeryDry',
    Dry: 'Dry',
    Normal: 'Normal',
    Wet: 'Wet',
    VeryWet: 'VeryWet',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var State = {
    Dolnoslaskie: 'Dolnoslaskie',
    KujawskoPomorskie: 'KujawskoPomorskie',
    Lubelskie: 'Lubelskie',
    Lubuskie: 'Lubuskie',
    Lodzkie: 'Lodzkie',
    Malopolskie: 'Malopolskie',
    Mazowieckie: 'Mazowieckie',
    Opolskie: 'Opolskie',
    Podkarpackie: 'Podkarpackie',
    Podlaskie: 'Podlaskie',
    Pomorskie: 'Pomorskie',
    Slaskie: 'Slaskie',
    Swietokrzyskie: 'Swietokrzyskie',
    WarminskoMazurskie: 'WarminskoMazurskie',
    Wielkopolskie: 'Wielkopolskie',
    Zachodniopomorskie: 'Zachodniopomorskie',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var StorageSensorMeasurementTypes = {
    AirTemperature: 0,
    AirHumidity: 1,
    SoilTemperature: 2,
    SoilHumidityLevel1: 3,
    SoilHumidityLevel2: 4,
    SoilHumidityLevel3: 5,
    WindSpeed: 6,
    WindDirection: 7,
    RainCount: 8,
    SunLevel: 9,
    AirPressure: 10,
    BatteryLevel: 11,
    BatteryPercentage: 12,
    CO2: 13,
};
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.AirTemperature] = 'AirTemperature';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.AirHumidity] = 'AirHumidity';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.SoilTemperature] = 'SoilTemperature';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.SoilHumidityLevel1] = 'SoilHumidityLevel1';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.SoilHumidityLevel2] = 'SoilHumidityLevel2';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.SoilHumidityLevel3] = 'SoilHumidityLevel3';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.WindSpeed] = 'WindSpeed';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.WindDirection] = 'WindDirection';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.RainCount] = 'RainCount';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.SunLevel] = 'SunLevel';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.AirPressure] = 'AirPressure';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.BatteryLevel] = 'BatteryLevel';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.BatteryPercentage] = 'BatteryPercentage';
StorageSensorMeasurementTypes[StorageSensorMeasurementTypes.CO2] = 'CO2';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var StorageSensorStatus = {
    Deleted: 'Deleted',
    Registered: 'Registered',
    NotRegistered: 'NotRegistered',
    Broadcast: 'Broadcast',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var SupplierType = {
    Contracting: 'Contracting',
    Production: 'Production',
    Trading: 'Trading',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ThresholdOperator = {
    GreaterThan: 'GreaterThan',
    GreaterThanOrEqual: 'GreaterThanOrEqual',
    LessThan: 'GreaterThan',
    LessThanOrEqual: 'LessThanOrEqual',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TreatmentFertilizerUnit = {
    Tonne: 'Tonne',
    Kilogram: 'Kilogram',
    Gram: 'Gram',
    Liter: 'Liter',
    Milliliter: 'Milliliter',
    Piece: 'Piece',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TreatmentIrrigationUnit = {
    Liter: 'Liter',
    Cubic: 'Cubic',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TreatmentPesticideUnit = {
    Tonne: 'Tonne',
    Kilogram: 'Kilogram',
    Gram: 'Gram',
    Liter: 'Liter',
    Milliliter: 'Milliliter',
    Piece: 'Piece',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TreatmentSeedUnit = {
    SeedUnit: 'SeedUnit',
    Tonne: 'Tonne',
    Kilogram: 'Kilogram',
    Gram: 'Gram',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TreatmentType = {
    Sowing: 'TreatmentType.Sowing',
    Tillage: 'TreatmentType.Tillage',
    Cultivation: 'TreatmentType.Cultivation',
    Fertilization: 'TreatmentType.Fertilization',
    Spraying: 'TreatmentType.Spraying',
    Harvesting: 'TreatmentType.Harvesting',
    Planting: 'TreatmentType.Planting',
    Subsoiling: 'TreatmentType.Subsoiling',
    StubbleCultivation: 'TreatmentType.StubbleCultivation',
    IntercropsSowing: 'TreatmentType.IntercropsSowing',
    Irrigation: 'TreatmentType.Irrigation',
    Other: 'TreatmentType.Other',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TrueFalse = {
    True: 'True',
    False: 'False',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var WeatherStationMeasurementTypes = {
    AirTemperature: 0,
    AirHumidity: 1,
    SoilTemperature: 2,
    SoilHumidityLevel1: 3,
    SoilHumidityLevel2: 4,
    SoilHumidityLevel3: 5,
    WindSpeed: 6,
    WindDirection: 7,
    RainCount: 8,
    SunLevel: 9,
    AirPressure: 10,
    BatteryLevel: 11,
    BatteryPercentage: 12,
};
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.AirTemperature] = 'AirTemperature';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.AirHumidity] = 'AirHumidity';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.SoilTemperature] = 'SoilTemperature';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.SoilHumidityLevel1] = 'SoilHumidityLevel1';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.SoilHumidityLevel2] = 'SoilHumidityLevel2';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.SoilHumidityLevel3] = 'SoilHumidityLevel3';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.WindSpeed] = 'WindSpeed';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.WindDirection] = 'WindDirection';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.RainCount] = 'RainCount';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.SunLevel] = 'SunLevel';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.AirPressure] = 'AirPressure';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.BatteryLevel] = 'BatteryLevel';
WeatherStationMeasurementTypes[WeatherStationMeasurementTypes.BatteryPercentage] = 'BatteryPercentage';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var WeatherStationStatus = {
    Deleted: 'Deleted',
    Registered: 'Registered',
    NotRegistered: 'NotRegistered',
    Broadcast: 'Broadcast',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var WeatherStationThresholdOperator = {
    GreaterThan: 'GreaterThan',
    GreateThanOrEqual: 'GreateThanOrEqual',
    LessThan: 'LessThan',
    LessThanOrEqual: 'LessThanOrEqual',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var WorkPriceUnit = {
    H: 'h',
    Ha: 'ha',
    T: 't',
    Km: 'km',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var YesNo = {
    No: 'No',
    NotApplicable: 'NotApplicable',
    Yes: 'Yes',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageTypeIconPipe = /** @class */ (function () {
    function MessageTypeIconPipe() {
    }
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    MessageTypeIconPipe.prototype.transform = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        switch (value) {
            case MessageType.Advertisement:
                return 'ft-globe info';
            case MessageType.Alert:
                return 'ft-alert-circle danger';
            case MessageType.Information:
                return 'ft-info info';
            case MessageType.Reminder:
                return 'ft-bell warning';
            case MessageType.Standard:
                return 'ft-mail primary';
            case MessageType.Warning:
                return 'ft-alert-triangle warning';
            default:
                return 'ft-mail info';
        }
    };
    MessageTypeIconPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'messageTypeIcon'
                },] }
    ];
    return MessageTypeIconPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TemperaturePipe = /** @class */ (function (_super) {
    __extends(TemperaturePipe, _super);
    function TemperaturePipe(locale) {
        return _super.call(this, locale) || this;
    }
    /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    TemperaturePipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} locale
     * @return {?}
     */
    function (value, locale) {
        if (value == null) {
            return '-';
        }
        return _super.prototype.transform.call(this, value, '1.2-2', locale) + ' °C';
    };
    TemperaturePipe.decorators = [
        { type: Pipe, args: [{ name: 'temperature' },] }
    ];
    /** @nocollapse */
    TemperaturePipe.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
    ]; };
    return TemperaturePipe;
}(DecimalPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimePipe = /** @class */ (function () {
    function TimePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TimePipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var sec = value % 60;
        // tslint:disable-next-line: no-magic-numbers
        value /= 60.0;
        // tslint:disable-next-line: no-magic-numbers
        /** @type {?} */
        var minutes = value % 60;
        // tslint:disable-next-line: no-magic-numbers
        value /= 60.0;
        // tslint:disable-next-line: no-magic-numbers max-line-length
        return parseInt(value.toString(), 10).toString().padStart(2, '0') + ":" + parseInt(minutes.toString(), 10).toString().padStart(2, '0') + ":" + parseInt(sec.toString(), 10).toString().padStart(2, '0');
    };
    TimePipe.decorators = [
        { type: Pipe, args: [{ name: 'time' },] }
    ];
    return TimePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    PipesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AirHumidityPipe,
                        AirPressurePipe,
                        DefaultPipe,
                        FarmPortalWeatherStationsReplaceLinkPipe,
                        HtmlTextShortPipe,
                        HumidityPipe,
                        MessageTypeIconPipe,
                        TemperaturePipe,
                        TimePipe
                    ],
                    imports: [CommonModule$1],
                    entryComponents: [],
                    exports: [
                        AirHumidityPipe,
                        AirPressurePipe,
                        DefaultPipe,
                        FarmPortalWeatherStationsReplaceLinkPipe,
                        HtmlTextShortPipe,
                        HumidityPipe,
                        MessageTypeIconPipe,
                        TemperaturePipe,
                        TimePipe
                    ]
                },] }
    ];
    return PipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoggerService = /** @class */ (function () {
    function LoggerService(appConfigurationService, appInsights) {
        this.appConfigurationService = appConfigurationService;
        this.appInsights = appInsights;
        this.isInitialized = false;
    }
    /**
     * @param {?} errorObject
     * @return {?}
     */
    LoggerService.prototype.trackException = /**
     * @param {?} errorObject
     * @return {?}
     */
    function (errorObject) {
        this.appInsights.trackException(errorObject);
        this.appInsights.trackTrace('MESSAGE');
        this.appInsights.flush();
    };
    /**
     * @return {?}
     */
    LoggerService.prototype.initialize = /**
     * @return {?}
     */
    function () {
        if (this.isInitialized === false) {
            this.appInsights.config = {
                instrumentationKey: this.appConfigurationService.configuration.appinsight_key
            };
            this.appInsights.init();
            this.isInitialized = true;
        }
    };
    LoggerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LoggerService.ctorParameters = function () { return [
        { type: AppConfigurationService },
        { type: AppInsightsService }
    ]; };
    /** @nocollapse */ LoggerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(ɵɵinject(AppConfigurationService), ɵɵinject(AppInsightsService$1)); }, token: LoggerService, providedIn: "root" });
    return LoggerService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoggerService.prototype.isInitialized;
    /**
     * @type {?}
     * @private
     */
    LoggerService.prototype.appConfigurationService;
    /**
     * @type {?}
     * @private
     */
    LoggerService.prototype.appInsights;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable: no-any
var ErrorInterceptor = /** @class */ (function () {
    function ErrorInterceptor(notificationService) {
        this.notificationService = notificationService;
        this.resourcesToIgnore = [
            'dc.services.visualstudio.com',
            'login.microsoftonline.com'
        ];
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    ErrorInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        if (this.isIgnoredResource(req.url)) {
            return next.handle(req);
        }
        return next.handle(req).pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // tslint:disable-next-line: no-magic-numbers
            if (error.status !== 401) {
                // 401 handled in auth.interceptor
                _this.notificationService.error(error);
            }
            return throwError(error);
        })));
    };
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    ErrorInterceptor.prototype.isIgnoredResource = /**
     * @private
     * @param {?} url
     * @return {?}
     */
    function (url) {
        var e_1, _a;
        if (this.resourcesToIgnore) {
            try {
                for (var _b = __values(this.resourcesToIgnore), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var resourceToIgnore = _c.value;
                    if (url.indexOf(resourceToIgnore) > -1) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return false;
    };
    ErrorInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ErrorInterceptor.ctorParameters = function () { return [
        { type: NotificationService }
    ]; };
    return ErrorInterceptor;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype.resourcesToIgnore;
    /**
     * @type {?}
     * @private
     */
    ErrorInterceptor.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoggerModule = /** @class */ (function () {
    function LoggerModule() {
    }
    LoggerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule$1,
                        ApplicationInsightsModule.forRoot({
                            instrumentationKeySetLater: true
                        })
                    ],
                    exports: [
                        ApplicationInsightsModule
                    ]
                },] }
    ];
    return LoggerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ErrorsHandler = /** @class */ (function () {
    function ErrorsHandler(injector) {
        this.injector = injector;
        this.resourcesToIgnore = [
            'dc.services.visualstudio.com',
            'login.microsoftonline.com'
        ];
    }
    /**
     * @param {?} error
     * @return {?}
     */
    ErrorsHandler.prototype.handleError = /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        /** @type {?} */
        var notificationService = this.injector.get(NotificationService);
        /** @type {?} */
        var ngZone = this.injector.get(NgZone);
        if (error instanceof HttpErrorResponse) {
            if (this.isIgnoredResource(error.url)) {
                return;
            }
            return ngZone.run((/**
             * @return {?}
             */
            function () {
                return notificationService.error(error);
            }));
        }
        // Log the error
        try {
            console.error(error);
            /** @type {?} */
            var appInsightsService = this.injector.get(AppInsightsService);
            appInsightsService.trackException(error);
        }
        catch (error) {
            console.error(error);
        }
    };
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    ErrorsHandler.prototype.isIgnoredResource = /**
     * @private
     * @param {?} url
     * @return {?}
     */
    function (url) {
        var e_1, _a;
        if (this.resourcesToIgnore) {
            try {
                for (var _b = __values(this.resourcesToIgnore), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var resourceToIgnore = _c.value;
                    if (url.indexOf(resourceToIgnore) > -1) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return false;
    };
    ErrorsHandler.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ErrorsHandler.ctorParameters = function () { return [
        { type: Injector }
    ]; };
    return ErrorsHandler;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ErrorsHandler.prototype.resourcesToIgnore;
    /**
     * @type {?}
     * @private
     */
    ErrorsHandler.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Create a new injection token for injecting the window into a component. */
/** @type {?} */
var WINDOW = new InjectionToken('WindowToken');
/**
 * Based on https://brianflove.com/2018/01/11/angular-window-provider/
 * @abstract
 */
/* Define abstract class for obtaining reference to the global window object. */
var  /**
 * Based on https://brianflove.com/2018/01/11/angular-window-provider/
 * @abstract
 */
/* Define abstract class for obtaining reference to the global window object. */
WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: /**
         * @return {?}
         */
        function () {
            throw new Error('Not implemented.');
        },
        enumerable: true,
        configurable: true
    });
    return WindowRef;
}());
/* Define class that implements the abstract class and returns the native window object. */
var  /* Define class that implements the abstract class and returns the native window object. */
BrowserWindowRef = /** @class */ (function (_super) {
    __extends(BrowserWindowRef, _super);
    function BrowserWindowRef() {
        return _super.call(this) || this;
    }
    Object.defineProperty(BrowserWindowRef.prototype, "nativeWindow", {
        get: /**
         * @return {?}
         */
        function () {
            return window;
        },
        enumerable: true,
        configurable: true
    });
    return BrowserWindowRef;
}(WindowRef));
var WindowService = /** @class */ (function () {
    function WindowService(window) {
        this.window = window;
    }
    /**
     * @return {?}
     */
    WindowService.prototype.refreshPage = /**
     * @return {?}
     */
    function () {
        this.window.location.reload();
    };
    /** @nocollapse */
    WindowService.ctorParameters = function () { return [
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    return WindowService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WindowService.prototype.window;
}
var WindowPrintService = /** @class */ (function () {
    function WindowPrintService(window) {
        this.window = window;
    }
    /**
     * @return {?}
     */
    WindowPrintService.prototype.printPage = /**
     * @return {?}
     */
    function () {
        this.window.print();
    };
    /** @nocollapse */
    WindowPrintService.ctorParameters = function () { return [
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    return WindowPrintService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WindowPrintService.prototype.window;
}
var WindowScrollService = /** @class */ (function () {
    function WindowScrollService(window) {
        this.window = window;
    }
    /**
     * @param {?} pixelsToScrollOnInterval
     * @param {?} intervalTimeInMiliseconds
     * @return {?}
     */
    WindowScrollService.prototype.smoothScroolToTop = /**
     * @param {?} pixelsToScrollOnInterval
     * @param {?} intervalTimeInMiliseconds
     * @return {?}
     */
    function (pixelsToScrollOnInterval, intervalTimeInMiliseconds) {
        var _this = this;
        /** @type {?} */
        var scrollToTop = this.window.setInterval((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var pos = _this.window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - pixelsToScrollOnInterval);
            }
            else {
                window.clearInterval(scrollToTop);
            }
        }), intervalTimeInMiliseconds);
    };
    /** @nocollapse */
    WindowScrollService.ctorParameters = function () { return [
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    return WindowScrollService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WindowScrollService.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Create an factory function that returns the native window object. */
/**
 * @param {?} browserWindowRef
 * @param {?} platformId
 * @return {?}
 */
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
/** @type {?} */
var windowProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};
/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
/** @type {?} */
var browserWindowProvider = {
    provide: WindowRef,
    useClass: BrowserWindowRef
};
var CommonModule = /** @class */ (function () {
    function CommonModule() {
    }
    CommonModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        browserWindowProvider,
                        windowProvider,
                        WindowPrintService,
                        WindowService,
                        WindowScrollService
                    ]
                },] }
    ];
    return CommonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} array
 * @return {?}
 */
function randomNoRepeats(array) {
    /** @type {?} */
    var copy = array.slice(0);
    return (/**
     * @return {?}
     */
    function () {
        if (copy.length < 1) {
            copy = array.slice(0);
        }
        /** @type {?} */
        var index = Math.floor(Math.random() * copy.length);
        /** @type {?} */
        var item = copy[index];
        copy.splice(index, 1);
        return item;
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line: no-any
/**
 * @param {?} data
 * @return {?}
 */
function createFormData(data) {
    /** @type {?} */
    var formData = new FormData();
    buildFormData(formData, data, '', false);
    return formData;
}
/**
 * @param {?} formData
 * @param {?} data
 * @param {?} parentKey
 * @param {?} isPartOfArrayOfFiles
 * @return {?}
 */
function buildFormData(formData, data, parentKey, isPartOfArrayOfFiles) {
    if (data == null) {
        return;
    }
    if (typeof data !== 'object') {
        formData.append(parentKey, data);
        return;
    }
    if (data instanceof Date) {
        formData.append(parentKey, data);
        return;
    }
    if (data instanceof File) {
        formData.append(parentKey, data, data.name);
        return;
    }
    Object.keys(data).forEach((/**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var newParentKey = buildParentKey(data, key, parentKey, isPartOfArrayOfFiles);
        buildFormData(formData, data[key], newParentKey, isArrayOfFiles(data[key]));
    }));
}
/**
 * @param {?} data
 * @param {?} key
 * @param {?} parentKey
 * @param {?} isPartOfArrayOfFiles
 * @return {?}
 */
function buildParentKey(data, key, parentKey, isPartOfArrayOfFiles) {
    return parentKey
        ? isFile(data[key])
            ? isPartOfArrayOfFiles ? "" + parentKey : parentKey + "." + key
            : isArrayOfFiles(data[key]) ? parentKey + "." + key : parentKey + "[" + key + "]"
        : key;
}
/**
 * @param {?} data
 * @return {?}
 */
function isFile(data) {
    return data != null && data instanceof File;
}
/**
 * @param {?} data
 * @return {?}
 */
function isArrayOfFiles(data) {
    if (data != null && data instanceof Array) {
        return data.filter((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x != null; })).every((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x instanceof File; }));
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} key
 * @param {?=} instance
 * @return {?}
 */
function nameof(key, instance) {
    return key;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} enumIndex
 * @return {?}
 */
function getGeometryType(enumIndex) {
    switch (enumIndex) {
        case GeometryType.Point: {
            return 'Point';
        }
        case 'Point': {
            return 'Point';
        }
        case GeometryType.MultiPoint: {
            return 'MultiPoint';
        }
        case 'MultiPoint': {
            return 'MultiPoint';
        }
        case GeometryType.LineString: {
            return 'LineString';
        }
        case 'LineString': {
            return 'LineString';
        }
        case GeometryType.MultiLineString: {
            return 'MultiLineString';
        }
        case 'MultiLineString': {
            return 'MultiLineString';
        }
        case GeometryType.Polygon: {
            return 'Polygon';
        }
        case 'Polygon': {
            return 'Polygon';
        }
        case GeometryType.MultiPolygon: {
            return 'MultiPolygon';
        }
        case 'MultiPolygon': {
            return 'MultiPolygon';
        }
        case GeometryType.GeometryCollection: {
            return 'GeometryCollection';
        }
        case 'GeometryCollection': {
            return 'GeometryCollection';
        }
        default: {
            return 'Polygon';
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template T
 */
function ApiListResponse() { }
if (false) {
    /** @type {?} */
    ApiListResponse.prototype.items;
    /** @type {?} */
    ApiListResponse.prototype.pager;
}
/**
 * @record
 */
function ApiResponsePager() { }
if (false) {
    /** @type {?} */
    ApiResponsePager.prototype.totalCount;
    /** @type {?} */
    ApiResponsePager.prototype.currentPage;
    /** @type {?} */
    ApiResponsePager.prototype.pageSize;
    /** @type {?} */
    ApiResponsePager.prototype.totalPages;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ValidationFailure() { }
if (false) {
    /** @type {?} */
    ValidationFailure.prototype.attemptedValue;
    /** @type {?} */
    ValidationFailure.prototype.customState;
    /** @type {?} */
    ValidationFailure.prototype.errorCode;
    /** @type {?} */
    ValidationFailure.prototype.errorMessage;
    /** @type {?} */
    ValidationFailure.prototype.formattedMessageArguments;
    /** @type {?} */
    ValidationFailure.prototype.formattedMessagePlaceholderValues;
    /** @type {?} */
    ValidationFailure.prototype.propertyName;
    /** @type {?} */
    ValidationFailure.prototype.resourceName;
    /** @type {?} */
    ValidationFailure.prototype.severity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ValidationResult() { }
if (false) {
    /** @type {?} */
    ValidationResult.prototype.errors;
    /** @type {?} */
    ValidationResult.prototype.isValid;
    /** @type {?} */
    ValidationResult.prototype.ruleSetsExecuted;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template TFilter
 */
function RequestList() { }
if (false) {
    /** @type {?} */
    RequestList.prototype.filter;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} url
 * @param {?} requestList
 * @return {?}
 */
function prepareListUrl(url, requestList) {
    return prepareListUrlWithFilter(url, requestList, (/**
     * @return {?}
     */
    function () { return []; }));
}
/**
 * @template T
 * @param {?} url
 * @param {?} requestList
 * @param {?=} func
 * @return {?}
 */
function prepareListUrlWithFilter(url, requestList, func) {
    if (func === void 0) { func = null; }
    /** @type {?} */
    var params = [];
    if (requestList.pageSize != null) {
        params.push("PageSize=" + requestList.pageSize);
    }
    if (requestList.page != null) {
        params.push("Page=" + (requestList.page + 1)); // back-end start page from 1, front-end from 0.
    }
    if (requestList.orderBy) {
        params.push("OrderBy=" + requestList.orderBy);
    }
    if (requestList.sortOrder != null) {
        params.push("SortOrder=" + requestList.sortOrder);
    }
    if (func != null && requestList.filter != null) {
        params = __spread(params, func(requestList.filter));
    }
    if (params.length === 0) {
        return url;
    }
    return url + "?" + params.join('&');
}
/**
 * @template T
 * @param {?} httpParams
 * @param {?} requestList
 * @return {?}
 */
function prepareQueryArrayParams(httpParams, requestList) {
    /** @type {?} */
    var params = httpParams;
    params = preparePaginationQueryParams(params, requestList.page, requestList.pageSize);
    params = prepareOrderingQueryParams(params, requestList.orderBy, requestList.sortOrder);
    if (requestList.filter) {
        Object.keys(requestList.filter).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            if (requestList.filter[key] != null) {
                if (Array.isArray(requestList.filter[key])) {
                    requestList.filter[key].forEach((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) {
                        params = params.append(key, item);
                    }));
                }
                else {
                    params = params.set(key, requestList.filter[key]);
                }
            }
        }));
    }
    return params;
}
/**
 * @template T
 * @param {?} httpParams
 * @param {?} requestList
 * @return {?}
 */
function prepareQueryParams(httpParams, requestList) {
    /** @type {?} */
    var params = httpParams;
    params = preparePaginationQueryParams(params, requestList.page, requestList.pageSize);
    params = prepareOrderingQueryParams(params, requestList.orderBy, requestList.sortOrder);
    if (requestList.filter) {
        Object.keys(requestList.filter).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            if (requestList.filter[key] != null) {
                params = params.set(key, requestList.filter[key]);
            }
        }));
    }
    return params;
}
/**
 * @param {?} httpParams
 * @param {?=} page
 * @param {?=} pageSize
 * @return {?}
 */
function preparePaginationQueryParams(httpParams, page, pageSize) {
    /** @type {?} */
    var params = httpParams;
    if (page != null) {
        params = params.set('page', String(page + 1)); // back-end start page from 1, front-end from 0.
    }
    if (pageSize != null) {
        params = params.set('pageSize', String(pageSize));
    }
    return params;
}
/**
 * @param {?} httpParams
 * @param {?=} orderBy
 * @param {?=} sortOrder
 * @return {?}
 */
function prepareOrderingQueryParams(httpParams, orderBy, sortOrder) {
    /** @type {?} */
    var params = httpParams;
    if (orderBy) {
        params = params.set('orderBy', orderBy);
    }
    if (sortOrder != null) {
        params = params.set('sortOrder', sortOrder);
    }
    return params;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template TInterface, TClass
 */
function Adapter() { }
if (false) {
    /**
     * @param {?} item
     * @return {?}
     */
    Adapter.prototype.adapt = function (item) { };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DateUtilService = /** @class */ (function () {
    function DateUtilService() {
    }
    /**
     * @param {?} timestamp
     * @return {?}
     */
    DateUtilService.prototype.fromTimestampToDate = /**
     * @param {?} timestamp
     * @return {?}
     */
    function (timestamp) {
        /** @type {?} */
        var multiplier = 1000;
        return new Date(timestamp * multiplier);
    };
    /**
     * @param {?} timestamp
     * @return {?}
     */
    DateUtilService.prototype.fromTimestampToString = /**
     * @param {?} timestamp
     * @return {?}
     */
    function (timestamp) {
        /** @type {?} */
        var multiplier = 1000;
        /** @type {?} */
        var date = new Date(timestamp * multiplier);
        return this.fromDateToSting(date);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DateUtilService.prototype.fromDateToTimestamp = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        if (date == null) {
            return null;
        }
        /** @type {?} */
        var multiplier = 1000;
        return date.getTime() / multiplier;
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DateUtilService.prototype.fromDateToSting = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        if (date == null) {
            return null;
        }
        return format(date, 'yyyy-MM-dd');
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DateUtilService.prototype.fromStringToTimestamp = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        if (date == null) {
            return null;
        }
        /** @type {?} */
        var dateValue = new Date(date);
        return this.fromDateToTimestamp(dateValue);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DateUtilService.prototype.fromStringToDate = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date == null ? null : new Date(date);
    };
    /**
     * @param {?} month
     * @return {?}
     */
    DateUtilService.prototype.getMaxDays = /**
     * @param {?} month
     * @return {?}
     */
    function (month) {
        /** @type {?} */
        var day31 = 31;
        /** @type {?} */
        var day29 = 29;
        /** @type {?} */
        var day30 = 30;
        switch (month) {
            case Month.January:
                return day31;
            case Month.February:
                return day29;
            case Month.March:
                return day31;
            case Month.April:
                return day30;
            case Month.May:
                return day31;
            case Month.June:
                return day30;
            case Month.July:
                return day31;
            case Month.August:
                return day31;
            case Month.September:
                return day30;
            case Month.October:
                return day31;
            case Month.November:
                return day30;
            case Month.December:
                return day31;
        }
    };
    /**
     * @param {?} month
     * @return {?}
     */
    DateUtilService.prototype.getMonthIndex = /**
     * @param {?} month
     * @return {?}
     */
    function (month) {
        switch (month) {
            case Month.January:
                return 1;
            case Month.February:
                // tslint:disable-next-line: no-magic-numbers
                return 2;
            case Month.March:
                // tslint:disable-next-line: no-magic-numbers
                return 3;
            case Month.April:
                // tslint:disable-next-line: no-magic-numbers
                return 4;
            case Month.May:
                // tslint:disable-next-line: no-magic-numbers
                return 5;
            case Month.June:
                // tslint:disable-next-line: no-magic-numbers
                return 6;
            case Month.July:
                // tslint:disable-next-line: no-magic-numbers
                return 7;
            case Month.August:
                // tslint:disable-next-line: no-magic-numbers
                return 8;
            case Month.September:
                // tslint:disable-next-line: no-magic-numbers
                return 9;
            case Month.October:
                // tslint:disable-next-line: no-magic-numbers
                return 10;
            case Month.November:
                // tslint:disable-next-line: no-magic-numbers
                return 11;
            case Month.December:
                // tslint:disable-next-line: no-magic-numbers
                return 12;
        }
    };
    /**
     * @param {?} monthIndex
     * @return {?}
     */
    DateUtilService.prototype.getMonth = /**
     * @param {?} monthIndex
     * @return {?}
     */
    function (monthIndex) {
        switch (monthIndex) {
            case 1:
                return Month.January;
            // tslint:disable-next-line: no-magic-numbers
            case 2:
                return Month.February;
            // tslint:disable-next-line: no-magic-numbers
            case 3:
                return Month.March;
            // tslint:disable-next-line: no-magic-numbers
            case 4:
                return Month.April;
            // tslint:disable-next-line: no-magic-numbers
            case 5:
                return Month.May;
            // tslint:disable-next-line: no-magic-numbers
            case 6:
                return Month.June;
            // tslint:disable-next-line: no-magic-numbers
            case 7:
                return Month.July;
            // tslint:disable-next-line: no-magic-numbers
            case 8:
                return Month.August;
            // tslint:disable-next-line: no-magic-numbers
            case 9:
                return Month.September;
            // tslint:disable-next-line: no-magic-numbers
            case 10:
                return Month.October;
            // tslint:disable-next-line: no-magic-numbers
            case 11:
                return Month.November;
            // tslint:disable-next-line: no-magic-numbers
            case 12:
                return Month.December;
        }
    };
    DateUtilService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ DateUtilService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DateUtilService_Factory() { return new DateUtilService(); }, token: DateUtilService, providedIn: "root" });
    return DateUtilService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NumberUtilService = /** @class */ (function () {
    function NumberUtilService() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberUtilService.prototype.round2 = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return Math.round(value * NumberUtilService.TWO) / NumberUtilService.TWO;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NumberUtilService.prototype.round3 = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return Math.round(value * NumberUtilService.THREE) / NumberUtilService.THREE;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NumberUtilService.prototype.round4 = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return Math.round(value * NumberUtilService.FOUR) / NumberUtilService.FOUR;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NumberUtilService.prototype.round5 = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return Math.round(value * NumberUtilService.FIVE) / NumberUtilService.FIVE;
    };
    NumberUtilService.TWO = 100;
    NumberUtilService.THREE = 1000;
    NumberUtilService.FOUR = 10000;
    NumberUtilService.FIVE = 100000;
    NumberUtilService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ NumberUtilService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NumberUtilService_Factory() { return new NumberUtilService(); }, token: NumberUtilService, providedIn: "root" });
    return NumberUtilService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    NumberUtilService.TWO;
    /**
     * @type {?}
     * @private
     */
    NumberUtilService.THREE;
    /**
     * @type {?}
     * @private
     */
    NumberUtilService.FOUR;
    /**
     * @type {?}
     * @private
     */
    NumberUtilService.FIVE;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var DictionaryMode = {
    Dynamic: 0,
    Static: 1,
};
DictionaryMode[DictionaryMode.Dynamic] = 'Dynamic';
DictionaryMode[DictionaryMode.Static] = 'Static';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DICTIONARIES_SERVICES = new InjectionToken('DICTIONARIES_SERVICES');
var DictionariesService = /** @class */ (function () {
    function DictionariesService(dictionariesServices) {
        var _this = this;
        this.dictionariesServices = dictionariesServices;
        // tslint:disable-next-line: no-any
        this.cachedDictionaries = {};
        this.dictionariesServices.forEach((/**
         * @param {?} dictionaryService
         * @return {?}
         */
        function (dictionaryService) {
            if (dictionaryService.mode === DictionaryMode.Static) {
                _this.cachedDictionaries[dictionaryService.type] = dictionaryService.loadData().pipe(shareReplay());
            }
            else {
                _this.cachedDictionaries[dictionaryService.type] = dictionaryService.loadData().pipe();
            }
        }));
    }
    /**
     * @template K
     * @param {?} key
     * @return {?}
     */
    DictionariesService.prototype.getItems = /**
     * @template K
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return this.cachedDictionaries[key];
    };
    /**
     * @template K
     * @param {?} key
     * @return {?}
     */
    DictionariesService.prototype.getDropdownItems = /**
     * @template K
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var mapItem = this.dictionariesServices.find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.type === key; })).mapItem;
        return this.cachedDictionaries[key].pipe(map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x.map(mapItem); })));
    };
    DictionariesService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    DictionariesService.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: Inject, args: [DICTIONARIES_SERVICES,] }] }
    ]; };
    return DictionariesService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DictionariesService.prototype.cachedDictionaries;
    /**
     * @type {?}
     * @private
     */
    DictionariesService.prototype.dictionariesServices;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var  /**
 * @abstract
 * @template T
 */
DictionaryServiceBase = /** @class */ (function () {
    function DictionaryServiceBase() {
    }
    /**
     * @return {?}
     */
    DictionaryServiceBase.prototype.loadData = /**
     * @return {?}
     */
    function () {
        throw new Error('Implement dictionary loading data');
    };
    // tslint:disable-next-line: no-any
    // tslint:disable-next-line: no-any
    /**
     * @param {?} item
     * @return {?}
     */
    DictionaryServiceBase.prototype.mapItem = 
    // tslint:disable-next-line: no-any
    /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return { value: item.codeName, label: item.codeName };
    };
    return DictionaryServiceBase;
}());
if (false) {
    /** @type {?} */
    DictionaryServiceBase.prototype.type;
    /** @type {?} */
    DictionaryServiceBase.prototype.mode;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var DictionaryType = {
    ActiveSubstanceType: 0,
    Agrofag: 1,
    CultivationCrop: 2,
    CultivationInterCrop: 3,
    FertilizerType: 4,
    MachineType: 5,
    PesticideType: 6,
    SeedType: 7,
    TreatmentType: 8,
    BuildingType: 9,
};
DictionaryType[DictionaryType.ActiveSubstanceType] = 'ActiveSubstanceType';
DictionaryType[DictionaryType.Agrofag] = 'Agrofag';
DictionaryType[DictionaryType.CultivationCrop] = 'CultivationCrop';
DictionaryType[DictionaryType.CultivationInterCrop] = 'CultivationInterCrop';
DictionaryType[DictionaryType.FertilizerType] = 'FertilizerType';
DictionaryType[DictionaryType.MachineType] = 'MachineType';
DictionaryType[DictionaryType.PesticideType] = 'PesticideType';
DictionaryType[DictionaryType.SeedType] = 'SeedType';
DictionaryType[DictionaryType.TreatmentType] = 'TreatmentType';
DictionaryType[DictionaryType.BuildingType] = 'BuildingType';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActiveSubstanceTypeDictionaryService = /** @class */ (function (_super) {
    __extends(ActiveSubstanceTypeDictionaryService, _super);
    function ActiveSubstanceTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.ActiveSubstanceType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    ActiveSubstanceTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/v1/active_substances";
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.dictionaryType = DictionaryType[DictionaryType.ActiveSubstanceType];
            x.codeName = x.name;
            return x;
        })); })));
    };
    ActiveSubstanceTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ActiveSubstanceTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return ActiveSubstanceTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    ActiveSubstanceTypeDictionaryService.prototype.type;
    /** @type {?} */
    ActiveSubstanceTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    ActiveSubstanceTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    ActiveSubstanceTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AgrofagTypeDictionaryService = /** @class */ (function (_super) {
    __extends(AgrofagTypeDictionaryService, _super);
    function AgrofagTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.Agrofag;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    AgrofagTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/v1/agrofags";
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.dictionaryType = DictionaryType[DictionaryType.Agrofag];
            x.codeName = x.agrofag;
            return x;
        })); })));
    };
    AgrofagTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AgrofagTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return AgrofagTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    AgrofagTypeDictionaryService.prototype.type;
    /** @type {?} */
    AgrofagTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    AgrofagTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    AgrofagTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line: cognitive-complexity
/**
 * @param {?} oldObject
 * @return {?}
 */
function toCamel(oldObject) {
    /** @type {?} */
    var newObject;
    /** @type {?} */
    var originalKey;
    /** @type {?} */
    var newKey;
    /** @type {?} */
    var value;
    if (oldObject instanceof Array) {
        return oldObject.map((/**
         * @param {?} arrayItem
         * @return {?}
         */
        function (arrayItem) {
            if (typeof arrayItem === 'object') {
                arrayItem = toCamel(arrayItem);
            }
            return arrayItem;
        }));
    }
    else {
        newObject = {};
        for (originalKey in oldObject) {
            if (oldObject.hasOwnProperty(originalKey)) {
                newKey = (originalKey.charAt(0).toLowerCase() + originalKey.slice(1) || originalKey).toString();
                value = oldObject[originalKey];
                if (value instanceof Array || (value !== null && value.constructor === Object)) {
                    value = toCamel(value);
                }
                newObject[newKey] = value;
            }
        }
    }
    return newObject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FertilizerTypeDictionaryService = /** @class */ (function (_super) {
    __extends(FertilizerTypeDictionaryService, _super);
    function FertilizerTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.FertilizerType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    FertilizerTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/v1/fertilizers?page=1&pageSize=999999&fields=name";
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items; })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return (/** @type {?} */ (toCamel(x))); })); })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.dictionaryType = DictionaryType[DictionaryType.FertilizerType];
            x.codeName = x.name;
            return x;
        })); })));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FertilizerTypeDictionaryService.prototype.mapItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return { label: item.name, value: JSON.stringify({ rowKey: item.rowKey, name: item.name }) };
    };
    FertilizerTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    FertilizerTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return FertilizerTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    FertilizerTypeDictionaryService.prototype.type;
    /** @type {?} */
    FertilizerTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    FertilizerTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    FertilizerTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationCropDictionaryService = /** @class */ (function (_super) {
    __extends(CultivationCropDictionaryService, _super);
    function CultivationCropDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.CultivationCrop;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    CultivationCropDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/definitions/cultivations/crops";
        return this.httpClient.get(url);
    };
    CultivationCropDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CultivationCropDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return CultivationCropDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    CultivationCropDictionaryService.prototype.type;
    /** @type {?} */
    CultivationCropDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    CultivationCropDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    CultivationCropDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CultivationInterCropDictionaryService = /** @class */ (function (_super) {
    __extends(CultivationInterCropDictionaryService, _super);
    function CultivationInterCropDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.CultivationInterCrop;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    CultivationInterCropDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/definitions/cultivations/intercrops";
        return this.httpClient.get(url);
    };
    CultivationInterCropDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CultivationInterCropDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return CultivationInterCropDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    CultivationInterCropDictionaryService.prototype.type;
    /** @type {?} */
    CultivationInterCropDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    CultivationInterCropDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    CultivationInterCropDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MachineTypeDictionaryService = /** @class */ (function (_super) {
    __extends(MachineTypeDictionaryService, _super);
    function MachineTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.MachineType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    MachineTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/definitions/machinetypes";
        return this.httpClient.get(url);
    };
    MachineTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MachineTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return MachineTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    MachineTypeDictionaryService.prototype.type;
    /** @type {?} */
    MachineTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    MachineTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    MachineTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PesticideTypeDictionaryService = /** @class */ (function (_super) {
    __extends(PesticideTypeDictionaryService, _super);
    function PesticideTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.PesticideType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    PesticideTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.getAllUrl + "&fields=name,rowKey,gracePeriods";
        return this.getData(url);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    PesticideTypeDictionaryService.prototype.mapItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return { label: item.name, value: JSON.stringify({ rowKey: +item.rowKey, name: item.name }) };
    };
    /**
     * @param {?} tenantId
     * @param {?} cultivationCode
     * @param {?} cultivationTypeCode
     * @return {?}
     */
    PesticideTypeDictionaryService.prototype.loadDataByCultivationAndCultivationType = /**
     * @param {?} tenantId
     * @param {?} cultivationCode
     * @param {?} cultivationTypeCode
     * @return {?}
     */
    function (tenantId, cultivationCode, cultivationTypeCode) {
        if (cultivationCode == null) {
            return of([]);
        }
        /** @type {?} */
        var url = this.getAllUrl + "&fields=name,rowKey,gracePeriods,eko&tenantId=" + tenantId + "&filter=cultivations.name," + cultivationCode;
        if (this.isEcological(cultivationTypeCode)) {
            url += ';eko,true';
        }
        return this.getData(url);
    };
    /**
     * @private
     * @param {?} cultivationTypeCode
     * @return {?}
     */
    PesticideTypeDictionaryService.prototype.isEcological = /**
     * @private
     * @param {?} cultivationTypeCode
     * @return {?}
     */
    function (cultivationTypeCode) {
        return [CultivationType.Agroecological, CultivationType.Ecological].some((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === cultivationTypeCode; }));
    };
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    PesticideTypeDictionaryService.prototype.getData = /**
     * @private
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items; })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return (/** @type {?} */ (toCamel(x))); })); })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.dictionaryType = DictionaryType[DictionaryType.PesticideType];
            x.codeName = x.name;
            return x;
        })); })));
    };
    Object.defineProperty(PesticideTypeDictionaryService.prototype, "getAllUrl", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this.config.configuration.api_url + "/api/v1/pesticides?page=1&pageSize=999999";
        },
        enumerable: true,
        configurable: true
    });
    PesticideTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PesticideTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return PesticideTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    PesticideTypeDictionaryService.prototype.type;
    /** @type {?} */
    PesticideTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    PesticideTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    PesticideTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SeedTypeDictionaryService = /** @class */ (function (_super) {
    __extends(SeedTypeDictionaryService, _super);
    function SeedTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.SeedType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    SeedTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/v1/seeds?page=1&pageSize=99999&fields=name,type";
        return this.httpClient.get(url)
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.items; })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return (/** @type {?} */ (toCamel(x))); })); })))
            .pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        function (result) { return result.map((/**
         * @param {?} x
         * @return {?}
         */
        function (x) {
            x.dictionaryType = DictionaryType[DictionaryType.SeedType];
            x.codeName = x.name;
            return x;
        })); })));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    SeedTypeDictionaryService.prototype.mapItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return { label: item.name, value: JSON.stringify({ rowKey: item.id, name: item.name }) };
    };
    SeedTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SeedTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return SeedTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    SeedTypeDictionaryService.prototype.type;
    /** @type {?} */
    SeedTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    SeedTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    SeedTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TreatmentTypeDictionaryService = /** @class */ (function (_super) {
    __extends(TreatmentTypeDictionaryService, _super);
    function TreatmentTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.TreatmentType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    TreatmentTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/definitions/treatments";
        return this.httpClient.get(url);
    };
    TreatmentTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreatmentTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return TreatmentTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    TreatmentTypeDictionaryService.prototype.type;
    /** @type {?} */
    TreatmentTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    TreatmentTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    TreatmentTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BuildingTypeDictionaryService = /** @class */ (function (_super) {
    __extends(BuildingTypeDictionaryService, _super);
    function BuildingTypeDictionaryService(httpClient, config) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.config = config;
        _this.type = DictionaryType.BuildingType;
        _this.mode = DictionaryMode.Static;
        return _this;
    }
    /**
     * @return {?}
     */
    BuildingTypeDictionaryService.prototype.loadData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = this.config.configuration.api_url + "/api/definitions/buildingtypes";
        return this.httpClient.get(url);
    };
    BuildingTypeDictionaryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BuildingTypeDictionaryService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AppConfigurationService }
    ]; };
    return BuildingTypeDictionaryService;
}(DictionaryServiceBase));
if (false) {
    /** @type {?} */
    BuildingTypeDictionaryService.prototype.type;
    /** @type {?} */
    BuildingTypeDictionaryService.prototype.mode;
    /**
     * @type {?}
     * @private
     */
    BuildingTypeDictionaryService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    BuildingTypeDictionaryService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ACTIVE_SUBSTANCE_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: ActiveSubstanceTypeDictionaryService };
/** @type {?} */
var AGROFAG_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: AgrofagTypeDictionaryService };
/** @type {?} */
var CULTIVATION_CROP_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: CultivationCropDictionaryService };
/** @type {?} */
var CULTIVATION_INTER_CROP_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: CultivationInterCropDictionaryService };
/** @type {?} */
var FERTILIZER_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: FertilizerTypeDictionaryService };
/** @type {?} */
var MACHINE_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: MachineTypeDictionaryService };
/** @type {?} */
var PESTICIDE_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: PesticideTypeDictionaryService };
/** @type {?} */
var SEED_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: SeedTypeDictionaryService };
/** @type {?} */
var TREATMENT_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: TreatmentTypeDictionaryService };
/** @type {?} */
var BUILDING_TYPE_DICT = { provide: DICTIONARIES_SERVICES, multi: true, useClass: BuildingTypeDictionaryService };
var DictionariesModule = /** @class */ (function () {
    function DictionariesModule() {
    }
    DictionariesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule$1,
                        ConfigurationModule
                    ],
                    providers: [
                        DictionariesService,
                        PesticideTypeDictionaryService,
                        ACTIVE_SUBSTANCE_TYPE_DICT,
                        AGROFAG_TYPE_DICT,
                        CULTIVATION_CROP_DICT,
                        CULTIVATION_INTER_CROP_DICT,
                        FERTILIZER_TYPE_DICT,
                        MACHINE_TYPE_DICT,
                        PESTICIDE_TYPE_DICT,
                        SEED_TYPE_DICT,
                        TREATMENT_TYPE_DICT,
                        BUILDING_TYPE_DICT
                    ]
                },] }
    ];
    return DictionariesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DictionaryTypeReturnType() { }
if (false) {
    /* Skipping unnamed member:
    [DictionaryType.ActiveSubstanceType]: Observable<IAgrofagTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.Agrofag]: Observable<IActiveSubstanceTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.CultivationCrop]: Observable<ICultivationDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.CultivationInterCrop]: Observable<ICultivationDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.FertilizerType]: Observable<IFertilizerTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.MachineType]: Observable<IMachineTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.PesticideType]: Observable<IPesticideTypeDictionaryModel[]>*/
    /* Skipping unnamed member:
    [DictionaryType.SeedType]: Observable<ISeedTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.TreatmentType]: Observable<ITreatmentTypeDictionaryModel[]>,*/
    /* Skipping unnamed member:
    [DictionaryType.BuildingType]: Observable<IBuildingTypeDictionaryModel[]>,*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DictionaryDropdownItem() { }
if (false) {
    /** @type {?} */
    DictionaryDropdownItem.prototype.label;
    /** @type {?} */
    DictionaryDropdownItem.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IActiveSubstanceTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    IActiveSubstanceTypeDictionaryModel.prototype.name;
    /** @type {?} */
    IActiveSubstanceTypeDictionaryModel.prototype.quantity;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAgrofagTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    IAgrofagTypeDictionaryModel.prototype.agrofag;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICultivationDictionaryModel() { }
if (false) {
    /** @type {?} */
    ICultivationDictionaryModel.prototype.cultivationCategory;
    /** @type {?} */
    ICultivationDictionaryModel.prototype.cultivationColor;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFertilizerTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.name;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.type;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.producer;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.barcode;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.species;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.dosage;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.nitrogen;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.phosphorus;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.calcium;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.magnesium;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.potassium;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.sulfur;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.manganese;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.boron;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.selenium;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.copper;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.iron;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.zinc;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.sodium;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.density;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.formulation;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.partitionKey;
    /** @type {?} */
    IFertilizerTypeDictionaryModel.prototype.rowKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IMachineTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    IMachineTypeDictionaryModel.prototype.selfDriving;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IPesticideTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    IPesticideTypeDictionaryModel.prototype.name;
    /** @type {?} */
    IPesticideTypeDictionaryModel.prototype.rowKey;
    /** @type {?} */
    IPesticideTypeDictionaryModel.prototype.gracePeriods;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ISeedTypeDictionaryModel() { }
if (false) {
    /** @type {?} */
    ISeedTypeDictionaryModel.prototype.name;
    /** @type {?} */
    ISeedTypeDictionaryModel.prototype.type;
    /** @type {?} */
    ISeedTypeDictionaryModel.prototype.id;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ITreatmentTypeDictionaryModel() { }

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FeatureConfiguration = /** @class */ (function () {
    // tslint:disable-next-line: no-any
    function FeatureConfiguration(configuration) {
        this.configuration = configuration;
    }
    /**
     * @param {?} feature
     * @return {?}
     */
    FeatureConfiguration.prototype.isEnabled = /**
     * @param {?} feature
     * @return {?}
     */
    function (feature) {
        /** @type {?} */
        var key = Object.keys(this.configuration).find((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return x === feature; }));
        return key && this.configuration[key];
    };
    return FeatureConfiguration;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FeatureConfiguration.prototype.configuration;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FeatureService = /** @class */ (function () {
    function FeatureService() {
    }
    /**
     * @return {?}
     */
    FeatureService.prototype.loadFeatures = /**
     * @return {?}
     */
    function () {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) {
            fetch('assets/features.config.json')
                .then((/**
             * @param {?} response
             * @return {?}
             */
            function (response) { return response.json(); }))
                .then((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                observer.next(new FeatureConfiguration(data));
                observer.complete();
            }))
                .catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) { return observer.error(err); }));
        }));
    };
    FeatureService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ FeatureService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(); }, token: FeatureService, providedIn: "root" });
    return FeatureService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GeolocationService = /** @class */ (function () {
    function GeolocationService(window) {
        this.window = window;
    }
    /**
     * @return {?}
     */
    GeolocationService.prototype.getCurrentPosition = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) {
            /** @type {?} */
            var watchId;
            if (_this.window && _this.window.navigator && _this.window.navigator.geolocation) {
                /** @type {?} */
                var opts = { enableHighAccuracy: true, maximumAge: 60000, timeout: 30000 };
                watchId = window.navigator.geolocation.watchPosition((/**
                 * @param {?} position
                 * @return {?}
                 */
                function (position) {
                    observer.next(position);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    switch (error.code) {
                        case 1:
                            observer.error('errors.location.permissionDenied');
                            break;
                        // tslint:disable-next-line: no-magic-numbers
                        case 2:
                            observer.error('errors.location.positionUnavailable');
                            break;
                        // tslint:disable-next-line: no-magic-numbers
                        case 3:
                            observer.error('errors.location.timeout');
                            break;
                    }
                }), opts);
            }
            else {
                observer.error('errors.location.unsupportedBrowser');
            }
            // When the consumer unsubscribes, clean up data ready for next subscription.
            return {
                unsubscribe: /**
                 * @return {?}
                 */
                function () {
                    navigator.geolocation.clearWatch(watchId);
                }
            };
        }));
    };
    /** @nocollapse */
    GeolocationService.ctorParameters = function () { return [
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] }
    ]; };
    return GeolocationService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    GeolocationService.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GeolocationModule = /** @class */ (function () {
    function GeolocationModule() {
    }
    GeolocationModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        GeolocationService
                    ]
                },] }
    ];
    return GeolocationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AgronomicCategory, AirHumidityPipe, AirPressurePipe, AlarmLocation, AlarmThresholdProperty, AppConfigurationService, AppInitService, ApplicationType, BrowserWindowRef, CertificateType, CommonModule, ComplexOfAgriculturalSuitability, ConfigurationModule, ContractAgreementType, ContractStatusType, ContractedProductUnit, Country, CultivationPotatoPurposeType, CultivationProtectionType, CultivationSubtype, CultivationType, CurrentUser, CurrentUserModule, CurrentUserService, CustomMapType, DICTIONARIES_SERVICES, DateUtilService, DefaultPipe, DeliveryAuditConsumptionType, DeliveryAuditDisease, DeliveryAuditFleshColor, DeliveryAuditQualitativeAssessment, DeliveryAuditSkinColor, DeliveryAuditTuberShape, DeliveryRatingCategoryType, DeviceType, DictionariesModule, DictionariesService, DictionaryTranslateKeyPipe, DictionaryType, DocumentEnumType, EmployeePosition, EmployeeTaskType, EmploymentSalaryType, EmploymentType, EnumItemGroup, EnumTranslateKeyPipe, ErrorInterceptor, ErrorMessageService, ErrorsHandler, FarmAuditStatus, FarmPortalWeatherStationsReplaceLinkPipe, FcTokenModule, FcTokenService, FcUser, FeatureConfiguration, FeatureService, FertilizerType, FieldAuditAreaType, FieldAuditType, GeolocationModule, GeolocationService, GeometryType, GroundCategory, HtmlTextShortPipe, HumidityPipe, I18nDatePipe, LimingType, LoadingSpinnerComponent, LoggerModule, LoggerService, MachineServiceCardType, MachineServiceCardUnit, MachineServiceType, ManureType, MapCultivationAreaModeEnum, MessageType, MessageTypeIconPipe, Month, NotificationModule, NotificationService, NumberUtilService, PesticideTypeDictionaryService, PipesModule, ProductCatalogAuditLaboratory, ProductCatalogAuditPlace, ProductCatalogAuditRecipient, ProductCatalogAuditResult, ProductCatalogAuditStatus, ProductCatalogAuditType, ProductCatalogAuditViewType, ProductCatalogInfoStatus, QualityAssessmentType, RainfallYearType, SpinnerDirective, SpinnerModule, SpinnerService, State, StorageSensorMeasurementTypes, StorageSensorStatus, StorageService, SupplierType, SupportedLanguages, TRANSLATE_MODULE_OPTIONS_CONFIG, TemperaturePipe, ThresholdOperator, TimePipe, TranslateService, TranslationModule, TreatmentFertilizerUnit, TreatmentIrrigationUnit, TreatmentPesticideUnit, TreatmentSeedUnit, TreatmentType, TrueFalse, WINDOW, WeatherStationMeasurementTypes, WeatherStationStatus, WeatherStationThresholdOperator, WindowPrintService, WindowRef, WindowScrollService, WindowService, WorkPriceUnit, YesNo, createFormData, getGeometryType, initAppConfiguration, initEmployeeTaskTypeItemsGroup, nameof, prepareListUrl, prepareListUrlWithFilter, prepareQueryArrayParams, prepareQueryParams, randomNoRepeats, toCamel, windowFactory, DynamicLocaleId as ɵa, LocaleProvider as ɵb, FcTokenService as ɵc, FcTokenInterceptor as ɵd, DictionaryServiceBase as ɵf, ActiveSubstanceTypeDictionaryService as ɵg, AgrofagTypeDictionaryService as ɵh, CultivationCropDictionaryService as ɵi, CultivationInterCropDictionaryService as ɵj, FertilizerTypeDictionaryService as ɵk, MachineTypeDictionaryService as ɵl, SeedTypeDictionaryService as ɵm, TreatmentTypeDictionaryService as ɵn, BuildingTypeDictionaryService as ɵo };
//# sourceMappingURL=farmcloud-core.js.map
